import NextImage from '@/components/NextImage';
import Button from '@/components/UI/Button';
import { CouponMiniIcon, WelfareIcon } from '@/components/UI/svg/Ecocredits';
import { loginUser } from '@/utils/cookie';
import { useGlobal } from '@/utils/useGlobal';
import React, { useEffect, useState } from 'react';
import css from './index.module.scss';
import { signupCookie } from '@/utils/cookies/signupCookie';

interface props {
    isLogin: boolean;
    rewardUserInfo: any;
    openModal: (key: string) => void;
    refershData: () => void;
}

const JoinEcoclub: React.FC<props> = ({ isLogin, rewardUserInfo, openModal, refershData }) => {
    const { useRouter, useLang, Link, isMobile, gtm } = useGlobal();
    const { locale } = useRouter();

    const { t } = useLang('ecocredits');
    const [baseUserInfo, setBaseUserInfo] = useState<any>({});
    const [href, setHref] = useState('');

    // const handleNextPage = () => {
    //     location.href = `https://${locale}.ecoflow.com/pages/autumn-sale`;
    // };

    useEffect(() => {
        const baseUserInfo = loginUser();
        setBaseUserInfo(baseUserInfo);
    }, []);

    useEffect(() => {
        setHref(window.location.href);
    }, []);
    return (
        <div className={`${css.join_ecoclub} ${isLogin ? 'login' : 'unlogin'}`}>
            <NextImage
                src={require(`@publicLocal/ecocredits/${isMobile ? 'h5' : 'pc'}/membership_banner.jpg`)}
                alt={t('join_title')}
                aria-label={t('join_title')}
            />
            <div className="wrapper">
                {isLogin ? (
                    <div className="content login">
                        <p className="member">
                            <span>{t('current_tier')}: </span>
                            <span>{t('membership')}</span>
                        </p>
                        <h1 className="join-title">{t('welcome_title', { username: baseUserInfo?.user?.name || baseUserInfo?.user?.email })}</h1>
                        <p className="join-desc">{t('welcome_sub_title')}</p>
                        <p className="join-desc">{t('welcome_text')}</p>
                    </div>
                ) : (
                    <div className="content unlogin">
                        <h1 className="join-title">{t('join_title')}</h1>
                        <p className="join-desc">{t('join_subTitle')}</p>
                        <div className="action">
                            <Link
                                href={`/${locale}/register?redirect=${encodeURIComponent(href)}`}
                                onClick={() => {
                                    signupCookie?.({
                                        sector_name: t('join_title'),
                                        entry_position: 1,
                                    });
                                }}
                            >
                                <Button
                                    className="btn register-btn"
                                    onClick={() =>
                                        gtm.push({
                                            event: 'uaEvent',
                                            event_name: 'select_banner',
                                            banner_name: t('join_title'),
                                            position: 'banner_1',
                                            button_name: t('join_now'),
                                        })
                                    }
                                >
                                    {t('join_now')}
                                </Button>
                            </Link>
                            <Link
                                href={`/${locale}/login?redirect=${encodeURIComponent(href)}`}
                                onClick={() => {
                                    signupCookie?.({
                                        sector_name: t('join_title'),
                                        entry_position: 1,
                                    });
                                }}
                            >
                                <Button
                                    className="btn login-btn"
                                    onClick={() =>
                                        gtm.push({
                                            event: 'uaEvent',
                                            event_name: 'select_banner',
                                            banner_name: t('join_title'),
                                            position: 'banner_1',
                                            button_name: t('login'),
                                        })
                                    }
                                >
                                    {t('login')}
                                </Button>
                            </Link>
                        </div>
                        <p className="join-tips">{t('join_tips')}</p>
                    </div>
                )}
            </div>

            {isLogin && (
                <ul className="summary-content" id="summary-content">
                    <li className="s-item points">
                        <div className="s-item-c">
                            <p className="s-value">
                                {rewardUserInfo?.points} <i>{t('points')}</i>
                            </p>
                            <p className="s-name">{t('points_balance')}</p>
                        </div>
                    </li>
                    <li className="s-item freeze-points">
                        <div className="s-item-c">
                            <p className="s-value disabled">
                                {rewardUserInfo?.frozenPoints} <i>{t('points')}</i>
                            </p>
                            <p className="s-name">{t('coming_soon')}</p>
                        </div>
                    </li>
                    <li className="s-item action">
                        <div className="s-item-d">
                            <Button
                                onClick={() => {
                                    openModal('coupon_modal');
                                    refershData && refershData();
                                }}
                                className="btn my_rewards"
                            >
                                <span className="btn-text">{t('rewards_redeemed')}</span>
                                {/* <EFArrowRightUp /> */}
                            </Button>
                            <Button
                                onClick={() => {
                                    openModal('history_modal');
                                    refershData && refershData();
                                }}
                                className="btn my_activity"
                            >
                                <span className="btn-text">{t('points_activity_a')}</span>
                                {/* <EFArrowRightUp /> */}
                            </Button>
                        </div>
                    </li>
                </ul>
            )}

            {isLogin && (
                <div className="welfare-center" onClick={() => openModal('bouns_modal')}>
                    <div className="welfare-desc">
                        <span className="welfare-text">{t('grab_title')}</span>
                        <span className="welfare-coupon-icon">
                            <CouponMiniIcon />
                        </span>
                    </div>
                    <div className="welfare-icon">
                        <WelfareIcon />
                    </div>
                </div>
            )}
        </div>
    );
};

export default JoinEcoclub;
